<template>
  <!-- prettier-ignore -->
  <div>
    <ovp-pin-dialog @submit="startCobrowse"/>
  </div>
</template>

<script>
import Vue from '@/setup'

import OvpPinDialog from './PinDialog'
import { LogHelper } from '@/helpers'

export default Vue.extend({
  name: 'CobrowseWidget',

  components: {
    OvpPinDialog,
  },

  methods: {
    createCobrowseName(reason) {
      const prefix = document.body.classList.contains('chat-open') ? 'Chat' : 'Telephone'
      return `${prefix} | ${reason}`
    },

    startCobrowse(data) {
      const cobrowseName = this.createCobrowseName(data.reason)
      this.$cobrowse.joinConversation(data.pin, cobrowseName).catch(e => {
        LogHelper.error(['Failed starting cobrowse-session', e])
        this.$notification.add(this.$t('cobrowse.invalid'), 'error')
      })
    },
  },
})
</script>
